<template lang="pug">
#cadastro-contrato-originacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        main
            section(v-if='!isAlvorada')
                h3.cadastro-contrato-originacao__subtitulo {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.subtituloInserirViaPlanilha') }}
                InserirViaPlanilha(
                    @atualizarTabelaContratosNaoEnviados='buscarContratosNaoEnviados'
                )

            section
                h3.cadastro-contrato-originacao__subtitulo {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.subtituloInserirViaManual') }}
                InserirManualmenteAlvorada(
                    v-if='isAlvorada',
                    @contrato-inserido='buscarContratosNaoEnviados'
                )
                InserirManualmentePY(
                    v-else-if='this.usuarioLogado.ambienteLogado === "PY"',
                    @contrato-inserido='buscarContratosNaoEnviados'
                )
                InserirManualmenteAR(
                    v-else-if='this.usuarioLogado.ambienteLogado === "AR"',
                    @contrato-inserido='buscarContratosNaoEnviados'
                )
                InserirManualmente(
                    v-else,
                    @contrato-inserido='buscarContratosNaoEnviados'
                )

            section
                .cadastro-contrato-originacao
                    h3.cadastro-contrato-originacao__subtitulo {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.subTituloListagemContratos') }}
                    el-tooltip(
                        effect='dark',
                        :content='$t("mensagens.sistema.recarregarTabela")',
                        placement='top',
                        v-if='btnRecarregar'
                    )
                        el-button(
                            type='info',
                            icon='el-icon-refresh',
                            size='mini',
                            @click.native='buscarContratosNaoEnviados'
                        )

                el-card(:body-style='{ padding: "0px" }', shadow='never')
                    TabelaAlvorada(
                        :key="listagemTableKey('inserir-alvorada', contratosNaoEnviados, paginacao.pagina + 1)",
                        v-if='isAlvorada',
                        :contratosNaoEnviados='contratosNaoEnviados',
                        :removendo='removendoContratos',
                        @contratosSelecionados='selecionarContratos',
                        :carregando='carregandoContratosNaoEnviados',
                        @ordenar='ordenarTabela'
                    )
                    TabelaPY(
                        :key="listagemTableKey('inserir-py', contratosNaoEnviados, paginacao.pagina + 1)",
                        v-else-if='this.usuarioLogado.ambienteLogado === "PY"',
                        :contratosNaoEnviados='contratosNaoEnviados',
                        :removendo='removendoContratos',
                        :ambiente='this.usuarioLogado.ambienteLogado',
                        @contratosSelecionados='selecionarContratos',
                        :carregando='carregandoContratosNaoEnviados',
                        @ordenar='ordenarTabela'
                    )
                    TabelaAR(
                        :key="listagemTableKey('inserir-ar', contratosNaoEnviados, paginacao.pagina + 1)",
                        v-else-if='this.usuarioLogado.ambienteLogado === "AR"',
                        :contratosNaoEnviados='contratosNaoEnviados',
                        :removendo='removendoContratos',
                        @contratosSelecionados='selecionarContratos',
                        :carregando='carregandoContratosNaoEnviados',
                        @ordenar='ordenarTabela'
                    )
                    Tabela(
                        :key="listagemTableKey('inserir', contratosNaoEnviados, paginacao.pagina + 1)",
                        v-else,
                        :contratosNaoEnviados='contratosNaoEnviados',
                        :removendo='removendoContratos',
                        :ambiente='this.usuarioLogado.ambienteLogado',
                        @contratosSelecionados='selecionarContratos',
                        :carregando='carregandoContratosNaoEnviados',
                        @ordenar='ordenarTabela'
                    )

                    .cadastro-contrato-originacao__paginador
                        b {{ qtdContratos }}
                        el-pagination(
                            small,
                            background,
                            layout='prev, pager, next',
                            :page-size='paginacao.tamanho',
                            :current-page.sync='paginacao.pagina',
                            :total='paginacao.total',
                            @current-change='atualizarPagina'
                        )

        footer
            .remover
                el-button(
                    v-if='removendoContratos',
                    @click.native='removendoContratos = false'
                ) {{ $t('mensagens.comuns.cancelar') }}

                el-button(
                    v-if='!removendoContratos',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoContratos = true'
                ) {{ $t('mensagens.comuns.remover') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerContratos'
                ) {{ $t('mensagens.comuns.confirmarRemocao') }}

            el-button(
                type='primary',
                icon='el-icon-s-promotion',
                @click.native='enviarContratos'
            ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.enviarContratos') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import InserirViaPlanilha from '@/components/contratosOriginacao/EmpresaBlocoInserirContratoViaPlanilha.vue';
import InserirManualmente from '@/components/contratosOriginacao/EmpresaBlocoInserirContratoManualmente.vue';
import InserirManualmentePY from '@/components/contratosOriginacao/EmpresaBlocoInserirContratoManualmentePY.vue';
import InserirManualmenteAR from '@/components/contratosOriginacao/EmpresaBlocoInserirContratoManualmenteAR.vue';
import InserirManualmenteAlvorada from '@/components/contratosOriginacao/EmpresaBlocoInserirContratoManualmenteAlvorada.vue';
import Tabela from '@/components/contratosOriginacao/EmpresaTabelaInserirContrato.vue';
import TabelaPY from '@/components/contratosOriginacao/EmpresaTabelaInserirContratoPY.vue';
import TabelaAR from '@/components/contratosOriginacao/EmpresaTabelaInserirContratoAR.vue';
import TabelaAlvorada from '@/components/contratosOriginacao/EmpresaTabelaInserirContratoAlvorada.vue';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa.js';
import { mapGetters } from 'vuex';

export default {
    name: 'CadastroContratoOriginacao',
    components: {
        BaseHeader,
        InserirViaPlanilha,
        InserirManualmente,
        InserirManualmentePY,
        InserirManualmenteAR,
        InserirManualmenteAlvorada,
        Tabela,
        TabelaAlvorada,
        TabelaPY,
        TabelaAR
    },

    data() {
        return {
            contratosNaoEnviados: [],
            contratosSelecionados: [],
            carregandoContratosNaoEnviados: false,
            paginacao: {
                pagina: 0,
                ordenacao: 'data_cadastro,desc',
                tamanho: 10,
                total: 0
            },
            removendoContratos: false,
            btnRecarregar: true
        };
    },

    computed: {
        qtdContratos() {
            return this.paginacao.total === 1
                ? '1 ' +
                      this.$t(
                          'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                      )
                : `${this.paginacao.total} ` +
                      this.$t(
                          'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratos'
                      );
        },
        ...mapGetters(['isAlvorada', 'usuarioLogado'])
    },

    mounted() {
        this.buscarContratosNaoEnviados();
    },

    methods: {
        async buscarContratosNaoEnviados() {
            if (this.usuarioLogado.ambienteLogado === 'AR') {
                this.buscarContratosNaoEnviadosAR();
            } else {
                this.buscarContratosNaoEnviadosDefault();
            }
        },

        async buscarContratosNaoEnviadosDefault() {
            this.carregandoContratosNaoEnviados = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.buscarContratosNaoEnviados(
                        this.paginacao
                    );
                this.contratosNaoEnviados = data.itens;
                this.paginacao.total = data.paginacao.total;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.erroBuscarContratos'
                    )
                );
            }
            this.carregandoContratosNaoEnviados = false;
        },

        async buscarContratosNaoEnviadosAR() {
            this.carregandoContratosNaoEnviados = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.buscarContratosNaoEnviadosAR(
                        this.paginacao
                    );
                this.contratosNaoEnviados = data.itens;
                this.paginacao.total = data.paginacao.total;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.erroBuscarContratos'
                    )
                );
            }
            this.carregandoContratosNaoEnviados = false;
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina;
            this.buscarContratosNaoEnviados();
        },

        ordenarTabela(ordenacao) {
            this.paginacao.ordenacao = ordenacao;
            this.buscarContratosNaoEnviados();
        },

        selecionarContratos(idsContratosOriginacao) {
            this.contratosSelecionados = idsContratosOriginacao;
        },

        async removerContratos() {
            if (this.contratosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.alertaSemContratosSelecionadosParaRemocao'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.contratosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.msgBoxTituloRemocaoContrato'
                          )
                        : this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.msgBoxTituloRemocaoContratos'
                          ),
                    this.$t('mensagens.comuns.aviso'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                );
                try {
                    if (this.usuarioLogado.ambienteLogado === 'AR') {
                        await ContratoOriginacaoServiceEmpresa.removerContratoLoteArgentina(
                            this.contratosSelecionados
                        );
                    } else {
                        await ContratoOriginacaoServiceEmpresa.removerContratoLote(
                            this.contratosSelecionados
                        );
                    }
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroRemoverContrato'
                        )
                    );
                }

                this.$notify.success(
                    this.contratosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoRemovido'
                          )
                        : this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosRemovido'
                          )
                );

                this.contratosSelecionados = [];
                this.buscarContratosNaoEnviados();
            }
        },

        async enviarContratos() {
            try {
                await ContratoOriginacaoServiceEmpresa.enviarContratos();
                this.buscarContratosNaoEnviados();
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratosEnviadosComSucesso'
                    )
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.erroAoEnviarContratos'
                    )
                );
            }
        }
    }
};
</script>

<style lang="scss">
#cadastro-contrato-originacao {
    main {
        margin: 16px 0;

        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .el-card {
        border-radius: 10px;
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .cadastro-contrato-originacao__paginador {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 4px 16px;

        b {
            color: var(--primary);
            font-size: 12px;
        }
    }

    .cadastro-contrato-originacao {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        align-items: center;
    }
    .cadastro-contrato-originacao__subtitulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }
}
</style>
